import React from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { ActionMeta, Props } from 'react-select';
import _ from 'lodash';
import { workspaceTypeOptions } from 'src/api/types';

interface WorkspaceTypeSelectProps extends Omit<Props, 'value'> {
  value: string;
  onChange: (value: { label: string; value: string }, meta: ActionMeta<any>) => void;
  error?: boolean;
  helperText?: string | false;
  disabled?: boolean;
  placeholder?: string;
  restrictedTo?: string[];
}

export const WorkspaceTypeSelect: React.FC<WorkspaceTypeSelectProps> = ({
  value,
  onChange,
  error,
  helperText,
  disabled,
  placeholder = 'Workspace type',
  restrictedTo,
  ...rest
}) => {
  const options = restrictedTo
    ? workspaceTypeOptions.filter((option) => restrictedTo.includes(option.value))
    : workspaceTypeOptions;

  const selectedValue = value ? _.find(options, (o) => o.value === value) : null;

  console.log('====options===', restrictedTo, options);

  return (
    <>
      <CSelect
        isDisabled={disabled}
        value={selectedValue}
        placeholder={placeholder}
        options={options}
        onChange={onChange}
        {...rest}
      />
      {error && helperText && <Error>{helperText}</Error>}
    </>
  );
};
